import * as React from "react";
const SvgFiRrCircleC = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-circle-c_svg__a)">
      <path
        fill="#062147"
        d="M12.038.019c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12m0 22c-5.514 0-10-4.486-10-10s4.486-10 10-10 10 4.486 10 10-4.486 10-10 10m-3.25-11.16v2.319c0 1.733 1.34 3.09 3.05 3.09h.453c.862 0 1.782-.37 2.238-.9a1 1 0 0 1 1.517 1.303c-.834.97-2.309 1.599-3.756 1.599h-.454c-2.784 0-5.049-2.284-5.049-5.091V10.86c0-2.807 2.265-5.091 5.05-5.091h.453a4.77 4.77 0 0 1 3.797 1.9 1 1 0 1 1-1.599 1.2 2.76 2.76 0 0 0-2.197-1.1h-.454c-1.71 0-3.049 1.358-3.049 3.09"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-circle-c_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCircleC;
